import React__default from 'react';
import styled, { css } from 'styled-components';
import { useIsMobile, isMobileStyleMixin } from '@amzn/storm-ui';
import { S as SearchProvider } from '../../contexts/Search/SearchProvider-g9yXpIGv.js';
import { C as CountrySelectorSearchInput } from './CountrySelectorSearchInput-D4os_iXJ.js';
import { C as CountrySelectorFooter } from './CountrySelectorFooter-CqYt-H7m.js';

const FlexContainer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40026394__sc-1j1eleo-0"
})(["display:flex;flex-direction:column;min-width:347px;", ""], isMobileStyleMixin(css(["height:100%;width:100vw;"])));
const CountrySelectorContent = ({
  children,
  id,
  countries,
  exclude,
  onClose,
  onSelect,
  applyButtonText
}) => {
  const isMobile = useIsMobile();
  return /*#__PURE__*/React__default.createElement(SearchProvider, {
    countries: countries,
    exclude: exclude
  }, /*#__PURE__*/React__default.createElement(FlexContainer, null, countries.length >= 10 && /*#__PURE__*/React__default.createElement(CountrySelectorSearchInput, {
    id: id
  }), children, !isMobile && /*#__PURE__*/React__default.createElement(CountrySelectorFooter, {
    id: id,
    countries: countries,
    onClose: onClose,
    onSelect: onSelect,
    applyButtonText: applyButtonText
  })));
};

export { CountrySelectorContent as C };
//# sourceMappingURL=CountrySelectorContent-b1bw3GZn.js.map
